/**
 * Ellipsis long strings
 * @param {int} count - max length
 * @param {string} long - string to truncate
 * @example truncate(24, 'Vila Bela da Santíssima Trindade') => will return Vila Bela da Santíssi...
 * @example truncate(24, 'Santo André') => will return Santo André
 */
const truncate = (count, long = '') => {
  let maxLength = count;
  if (long.length < maxLength) return long;
  if (maxLength === 3) maxLength += 3;
  return `${long.substr(0, maxLength - 3)}...`;
};

export default truncate;